module.exports = __webpack_public_path__ + "img/thumb-008-08.45b591f3.png";